import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

/** Public web config for the Failover project (safe to embed) — same project the phone + server use. */
export const firebaseConfig = {
  apiKey: "AIzaSyARPldNdlA_k28l_e2IDpdiAAzsjMtobF8",
  authDomain: "dev-failover.firebaseapp.com",
  projectId: "dev-failover",
  storageBucket: "dev-failover.firebasestorage.app",
  messagingSenderId: "135584924211",
  appId: "1:135584924211:web:b2700a00c88e419aea1946",
};

/**
 * Web Push (VAPID) public key — from Firebase console → Project settings → Cloud Messaging → Web Push
 * certificates → "Key pair". Needed by getToken() to mint a web FCM token. Left blank until the key is
 * pasted in; web push (push.ts) no-ops without it, so the rest of the app is unaffected.
 */
export const VAPID_KEY = "BJjd6ApvLRHyV2uKa3VK6K7TnzNeW4egLXKteK4kvwic6Pu5vSRHW-P4py_vtRUDYTOmx41K9LhaNwoghJMQ-TQ";

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

const useEmulator = Boolean(import.meta.env.VITE_USE_EMULATOR);
if (useEmulator) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}

/**
 * The web app is a LOGIN-LESS peer (like the phone): it signs in ANONYMOUSLY only to satisfy the
 * `signedIn()` Firestore rule — there's no Google account. All content is E2EE under the mirrored pairing
 * secrets, so anonymous auth grants no plaintext access. Resolves once there's a uid to gate reads/writes on.
 */
export function ensureAnonAuth(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (auth.currentUser) return resolve();
    signInAnonymously(auth).then(() => resolve()).catch(reject);
  });
}
